// extracted by mini-css-extract-plugin
export default {"journalFeed":"journal-feed_journalFeed__44pqk","withFeedInput":"journal-feed_withFeedInput__dXxA+"};